<div [formGroup]="parentForm()">
    <kendo-formfield showHints="initial" showErrors="initial">
      <kendo-label
        class="k-display-block label"
        [for]="multiselectOwners"
        text="Owners of this have the ability to modify it, including security."></kendo-label>
      <kendo-multiselect
        #multiselectOwners
        [data]="owners"
        [allowCustom]="true"
        textField="name"
        valueField="userId"
        [valuePrimitive]="false"
        [filterable]="true"
        (filterChange)="onFilterOwners($event)"
        formControlName="owners">
      </kendo-multiselect>
      <kendo-formerror>An owner is required.</kendo-formerror>
    </kendo-formfield>

    <div>
      <kendo-label
        class="k-display-block label"
        [for]="multiselectUsers"
        text="Granted users of this have the ability to add and use it."></kendo-label>
      <kendo-multiselect
        #multiselectUsers
        [data]="users"
        [allowCustom]="true"
        textField="name"
        valueField="userId"
        [valuePrimitive]="false"
        [filterable]="true"
        (filterChange)="onFilterUsers($event)"
        formControlName="users">
      </kendo-multiselect>
    </div>

    <div>
      <kendo-label
        class="k-display-block label"
        [for]="multiselectGroups"
        text="Granted groups of this have the ability to use it."></kendo-label>
      <kendo-multiselect
        #multiselectGroups
        [data]="groups"
        [allowCustom]="true"
        textField="displayName"
        valueField="id"
        [valuePrimitive]="false"
        [filterable]="true"
        (filterChange)="onFilterGroups($event)"
        formControlName="groups">
      </kendo-multiselect>
    </div>
  </div>
